import { SUPPORTED_LOCALES as e } from "../config.mjs";
import { useTranslation as t } from "react-i18next";
//#region src/hooks/useLocale.ts
var n = () => {
	let { i18n: n } = t();
	return {
		locale: n.language,
		dir: n.dir(n.language),
		supportedLocales: e
	};
};
//#endregion
export { n as useLocale };
